const AkRelationDataTable = {
    data: function () {
        return {
            idsSelected: this.defaultIdsSelected
        }
    },
    props: {
        type: {
            type: String,
            required: true
        },
        definition: {
            type: String,
            required: true
        },
        bundle: {
            type: String,
            required: true
        },
        relation: {
            type: String,
            default: '',
            required: true
        },
        childRelationString: {
            type: String,
            required: false
        },
        defaultIdsSelected: {
            type: Array,
            required: false,
            default: []
        }
    },
    computed: {
        queryForRelationTable() {
            // add the route query if we are in the skin settings so we can manage menu items fully
            // in other cases we don't want to pass the query or filters in it beceause the filters in the query
            // may not exist
            const query = this.$route.name === 'blueprint-skin-settings'
                    ? this.$route.query
                    : {};

            // add object id
            query.originalObjectId = this.$route.params.objectId;

            return query;
        },
        isListView() {
            return this.type === 'list';
        }
    },
    watch: {
        childRelationString: function(childRelationString) {
            //check if the relationID is updated
            //when we don't have a child relationId we are the active relationGrid so we refresh because a save took place
            if(childRelationString == undefined && this.$refs.dataTable) {
                this.$refs.dataTable.refresh();
                this.$refs.dataTable.refreshParam++;
            }
        }
    },
    methods: {
        updateSelection(selectedIds) {
            this.idsSelected = selectedIds;
        },
        refresh() {
            this.$emit('refresh', this.defaultIdsSelected);
        },
        save () {
            this.$emit('save', this.idsSelected);
            this.$emit('close', this.childRelationString);
        },
        cancel () {
            this.$emit('close', this.childRelationString);
        },
        selectNewDataObject(event, objectIdBeforeSave) {
            if (objectIdBeforeSave !== 'new') {
                return;
            }

            const maxSelectable = this.$refs.dataTable.selectables.maximum;
            const hasNoSelection = !this.$refs.dataTable.selection.idsSelected.length;
            const allowsMultiple = ! maxSelectable || maxSelectable > 1;
            const allowsSingleWhenEmpty = maxSelectable === 1 && hasNoSelection;

            if (allowsMultiple || allowsSingleWhenEmpty) {
                this.$refs.dataTable.selection.idsSelected.push(event.dataObjectId);
            }
        },
        updateRelationString(data) {
            let params = this.$route.params;
            // add the formDefinition & object Id to the relation ID
            params.relationString = params.relationString + ':form:'+ data.bundleId + ':' + data.definitionId + ':' + data.objectId;

            //redirect to the new relation state
            this.$router.push({ name: this.$route.name , params: params, query: this.$route.query});
        },
        /**
         * Trigger close
         */
        triggerClose() {
            const leftOverRelationString = this.$route.params.relationString.substring(0, this.$route.params.relationString.indexOf(this.childRelationString) - 1)

            this.$router.push({
                ...this.$route,
                params: {
                    ...this.$route.params,
                    relationString: leftOverRelationString
                }
            });
        }
    }
};
Vue.asyncComponent('ak-relation-data-table', AkRelationDataTable , 'grid/ak-relation-data-table.html');
export default AkRelationDataTable;